import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { UiComponents, UnoStoreHooks, UnoActions } from "@simulanisindia/ui";
import { useNavigate } from "react-router-dom";
import { fetchInitialAppData, getUserDetails } from "./apiClient/apiDataFetcher";
import Layout from "./layout/Layout";

const { FullScreenLoader } = UiComponents;
const { useUnoSelector, useUnoDispatch } = UnoStoreHooks;
const { saveUserData } = UnoActions;

function App() {
  const dispatch = useDispatch();
  const unoDispatch = useUnoDispatch();
  const userData = useUnoSelector((state) => state.user);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const currentURL = window.location.href;
  const urlObject = new URL(currentURL);
  const referrerUrlParam = urlObject.searchParams.get("referrer");

  const handleReferrer = async (referrer) => {
    const decoded = jwtDecode(referrer);
    const { token, redirectUri } = decoded;
    localStorage.setItem("token", token);
    const userDetails = await getUserDetails(token);
    unoDispatch(saveUserData(userDetails.data));
    setLoading(false);
    navigate(redirectUri);
  };

  if (referrerUrlParam) {
    handleReferrer(referrerUrlParam);
  }

  const initializePage = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const userDetails = await getUserDetails(token);
        unoDispatch(saveUserData(userDetails.data));
      }
      setLoading(false);
    } catch (error) {
      localStorage.removeItem("token");
      setLoading(false);
    }
  };

  useEffect(() => {
    initializePage();
  }, []);

  useEffect(() => {
    if (userData?.token) {
      fetchInitialAppData(dispatch, userData?.token);
    }
  }, [userData?.token]);

  return loading ? <FullScreenLoader /> : <Layout />;
}

export default App;
